import globalConsent from '../ads/gdpr/globalConsent';
import { getHostName, getParentUrlOrigin } from '../utils/urlUtils';

const { version } = require('../../package.json');

export default function contentCommonParams(config, exInfoData, customerId) {
  const urlOrigin = getParentUrlOrigin();
  return {
    // eslint-disable-next-line no-undef
    userAgent: navigator.userAgent,
    requestId: `${parseInt(Math.random() * 10000, 10)}${Date.now().toString().substr(-4)}${parseInt(
      Math.random() * 1000000000000,
      10,
    )}`,
    sdkVersion: version,
    source: urlOrigin,
    publisherId: config.poc.idCompany,
    publisherAdUnit: config.poc.idPub,
    data:
      customerId === process.env.TRACKER_CUSTOMER_ID_FOR_AD ? exInfoData : globalConsent.geo?.data, // globalConsent.geo?.data, // 'dXny46_t-2vL4-64EeqeVp7lqq_CXlUMe9SjM-_5WA0CKbyx8WMyfTF4yn-S0RV0Al-x63GgrrGy1xtgrFiuTPLs6Qviu0YKqX_qMEKAG5ekQEid5IRG43msBrBSAMq_',
    bundle: getHostName(urlOrigin),
    sdkType: 'tppxPlayer',
  };
}
